import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Teaser from "./teaser"

interface Article {
  headline: string
  preamble: string
  linkUrl: string
  image: {
    asset: {
      url: string
    }
  }
}

interface SanityArticles {
  nodes: [
    {
      sectionTitle: string
      articleList: Article[]
    }
  ]
}

export default () => {
  const {
    allSanityArticles,
  }: { allSanityArticles: SanityArticles } = useStaticQuery(graphql`
    query {
      allSanityArticles {
        nodes {
          sectionTitle
          articleList {
            headline
            preamble
            linkUrl
            image {
              asset {
                url
              }
            }
          }
        }
      }
    }
  `)

  const { nodes } = allSanityArticles
  const [articles] = nodes
  const { sectionTitle, articleList } = articles

  return (
    <section className="articles">
      <h2>{sectionTitle}</h2>

      {articleList.map((article, index) => {
        const { headline, preamble, linkUrl, image } = article
        return (
          <Teaser
            headline={headline}
            preamble={preamble}
            image={image}
            linkUrl={linkUrl}
            key={`teaser-${index}`}
          />
        )
      })}
    </section>
  )
}
